const base = function() {
  if (process.env.NODE_ENV === "development") {
    return "https://dev.api.al-nebras.net/api/";
    // return "http://127.0.0.1:8000/api/";
  } else if (process.env.NODE_ENV === "online_dev") {
    return "https://dev.api.al-nebras.net/api/";
  } else if (process.env.NODE_ENV === "testing") {
    return "https://dev.api.al-nebras.net/api/";
  } else if (process.env.NODE_ENV === "production") {
    return "https://api.al-nebras.net/api/";
  }
};
export const baseURL = base();
